import React, { useState } from "react"
import { Select, Space, Input, DatePicker } from "antd"
import { BENEFICIARY_REQUEST_STATUS, KYC_STATUS } from '../shared/payoutTag'
const BeneficiaryFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("userEmail")
  const searchBy = (
    <Select defaultValue="userEmail" className="select-before" onChange={value => setSearchField(value)}>
      <Select.Option value="userEmail">User Email</Select.Option>
      <Select.Option value="userId">User ID</Select.Option>
      <Select.Option value="guid">GUID</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={dates => (dates
            ? onFiltersChange({ ...filters, startDate: dates[0], endDate: dates[1] })
            : onFiltersChange({ ...filters, startDate: undefined, endDate: undefined })
          )}
        />
      </div>

      <div>
        Status:{' '}
        <Select
          placeholder="ALL"
          style={{ width: 180 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, status: value })}
        >
          {BENEFICIARY_REQUEST_STATUS.map((status) => (
            <Select.Option key={status.key} value={status.key}>
              {status.name}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  )
}

export default BeneficiaryFilters;
